// extracted by mini-css-extract-plugin
export default {"page":"Policy_page__71tML"};